// MIT License — (c) yourname; permission is hereby granted, free of charge, to any person obtaining a copy of this software...
(function () {
    // ======= CONFIG =======
    var DURATION_MS = 600; // default animation duration in ms
    var WHEEL_THRESHOLD = 100; // accumulated deltaY threshold for touchpad-like events
    var STRONG_WHEEL_DELTA = 60; // single-wheel event deltaY considered "strong" (immediate trigger)
    var WHEEL_ACCUM_RESET_MS = 250; // reset accumulated wheel delta after this idle time
    // ======================
    
    // Utility easing (easeInOutQuad)
    function easeInOutQuad(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    }
    
    // Get all sections in DOM order (no wrapper required)
    function getSections() {
        return Array.prototype.slice.call(document.querySelectorAll('.fp-section'));
    }
    
    // Get current scroll position
    function getScrollTop() {
        return window.pageYOffset || document.documentElement.scrollTop;
    }
    
    // Set scroll position
    function setScrollTop(val) {
        window.scrollTo(0, val);
    }
    
    // Get absolute top position of element relative to document
    function getElementTop(element) {
        var rect = element.getBoundingClientRect();
        return rect.top + getScrollTop();
    }
    
    // Smooth scroll implementation using requestAnimationFrame
    var isAnimating = false;
    function smoothScrollTo(target, duration) {
        if (isAnimating) return Promise.resolve();
        
        return new Promise(function (resolve) {
            isAnimating = true;
            var start = getScrollTop();
            var change = target - start;
            var startTime = performance.now();
            
            function step(now) {
                var elapsed = now - startTime;
                var t = Math.min(1, elapsed / duration);
                var eased = easeInOutQuad(t);
                setScrollTop(Math.round(start + change * eased));
                
                if (t < 1) {
                    requestAnimationFrame(step);
                } else {
                    // Ensure exact position at section top
                    setScrollTop(Math.round(target));
                    
                    // Ensure we're exactly at target position
                    setScrollTop(Math.round(target));
                    
                    // Longer delay to prevent immediate scroll detection
                    setTimeout(function() {
                        isAnimating = false;
                        resolve();
                    }, 150);
                }
            }
            requestAnimationFrame(step);
        });
    }
    
    // Determine current section index based on scroll position
    function getCurrentSectionIndex() {
        var sections = getSections();
        if (!sections.length) return -1;
        
        var scrollTop = getScrollTop();
        var viewportHeight = window.innerHeight;
        var viewportTop = scrollTop;
        var viewportBottom = scrollTop + viewportHeight;
        
        // Find section that is most visible in viewport
        for (var i = 0; i < sections.length; i++) {
            var sectionTop = getElementTop(sections[i]);
            var sectionBottom = sectionTop + sections[i].offsetHeight;
            
            // If section is mostly visible in viewport, this is current section
            var sectionVisibleTop = Math.max(sectionTop, viewportTop);
            var sectionVisibleBottom = Math.min(sectionBottom, viewportBottom);
            var visibleHeight = sectionVisibleBottom - sectionVisibleTop;
            
            if (visibleHeight > viewportHeight * 0.6) {
                return i;
            }
        }
        
        // Fallback: find section closest to viewport top (more stable)
        var bestIndex = 0;
        var bestDist = Infinity;
        
        for (var i = 0; i < sections.length; i++) {
            var sectionTop = getElementTop(sections[i]);
            var dist = Math.abs(sectionTop - viewportTop);
            
            if (dist < bestDist) {
                bestDist = dist;
                bestIndex = i;
            }
        }
        
        return bestIndex;
    }
    
    // Clamp helper
    function clamp(n, min, max) {
        return Math.max(min, Math.min(max, n));
    }
    
    // Go to a section by index (0-based)
    function goToSection(index) {
        var sections = getSections();
        if (!sections.length) return Promise.resolve();
        
        index = clamp(index, 0, sections.length - 1);
        var target = getElementTop(sections[index]);
        
        // Update last target section to prevent bounce-back
        lastTargetSection = index;
        
        return smoothScrollTo(target, DURATION_MS).then(function () {
            updateDots(index);
        });
    }
    
    // Next / Prev helpers
    function nextSection() {
        var idx = getCurrentSectionIndex();
        return goToSection(idx + 1);
    }
    
    function prevSection() {
        var idx = getCurrentSectionIndex();
        return goToSection(idx - 1);
    }
    
    // ===== Keyboard handling =====
    // Do not intercept if focus is inside interactive element
    function isFocusInsideInteractive() {
        var ae = document.activeElement;
        if (!ae) return false;
        
        var tag = ae.tagName.toLowerCase();
        if (tag === 'input' || tag === 'textarea' || tag === 'select') return true;
        if (ae.isContentEditable) return true;
        return false;
    }
    
    function onKeyDown(e) {
        if (isAnimating) return;
        if (isFocusInsideInteractive()) return; // let inputs handle keys
        
        var handled = false;
        switch (e.key) {
            case 'ArrowDown':
                nextSection();
                handled = true;
                break;
            case 'ArrowUp':
                prevSection();
                handled = true;
                break;
            case 'PageDown':
                nextSection();
                handled = true;
                break;
            case 'PageUp':
                prevSection();
                handled = true;
                break;
            case 'Home':
                goToSection(0);
                handled = true;
                break;
            case 'End':
                var sections = getSections();
                if (sections.length) goToSection(sections.length - 1);
                handled = true;
                break;
        }
        
        if (handled) {
            e.preventDefault();
            e.stopPropagation();
        }
    }
    
    // ===== Wheel / touchpad handling =====
    var wheelAccum = 0;
    var lastWheelTime = 0;
    
    function onWheel(e) {
        // Block all wheel events while animating
        if (isAnimating) {
            e.preventDefault();
            return;
        }
        
        var now = performance.now();
        var deltaY = e.deltaY;
        
        // Reset accumulation if idle for a bit
        if (now - lastWheelTime > WHEEL_ACCUM_RESET_MS) {
            wheelAccum = 0;
        }
        lastWheelTime = now;
        
        // If single strong wheel (mouse wheel notch), trigger immediately
        if (Math.abs(deltaY) >= STRONG_WHEEL_DELTA) {
            e.preventDefault();
            if (deltaY > 0) {
                nextSection();
            } else {
                prevSection();
            }
            wheelAccum = 0;
            return;
        }
        
        // Otherwise accumulate (touchpad behavior)
        wheelAccum += deltaY;
        
        // If accumulation exceeds threshold -> trigger
        if (Math.abs(wheelAccum) >= WHEEL_THRESHOLD) {
            e.preventDefault();
            if (wheelAccum > 0) {
                nextSection();
            } else {
                prevSection();
            }
            wheelAccum = 0;
            return;
        }
        
        // For small movements, let native scroll happen but prevent if at section edges
        var sections = getSections();
        if (!sections.length) return;
        
        var currentIndex = getCurrentSectionIndex();
        var scrollTop = getScrollTop();
        
        // Prevent scroll beyond first section (when trying to scroll up)
        if (currentIndex === 0 && deltaY < 0 && scrollTop <= 0) {
            e.preventDefault();
        }
        
        // Prevent scroll beyond last section (when trying to scroll down)
        if (currentIndex === sections.length - 1 && deltaY > 0) {
            var lastSection = sections[sections.length - 1];
            var lastSectionBottom = getElementTop(lastSection) + lastSection.offsetHeight;
            if (scrollTop + window.innerHeight >= lastSectionBottom) {
                e.preventDefault();
            }
        }
    }
    
    // ===== Dots navigation =====
    var dotsContainer = document.querySelector('.fp-dots');
    var dotButtons = [];
    
    function initDots() {
        dotsContainer = document.querySelector('.fp-dots');
        if (dotsContainer) {
            dotButtons = Array.prototype.slice.call(dotsContainer.querySelectorAll('button[data-index]'));
            dotButtons.forEach(function (btn) {
                btn.addEventListener('click', function (ev) {
                    var idx = parseInt(btn.getAttribute('data-index'), 10);
                    if (!isNaN(idx)) {
                        goToSection(idx);
                    }
                });
            });
        }
        
        // Initialize active state
        updateDots(getCurrentSectionIndex());
    }
    
    function updateDots(activeIndex) {
        if (dotsContainer && dotButtons.length) {
            dotButtons.forEach(function (b) {
                var idx = parseInt(b.getAttribute('data-index'), 10);
                if (idx === activeIndex) {
                    b.classList.add('active');
                } else {
                    b.classList.remove('active');
                }
            });
        }
        
        // Update CSS custom properties for visual dots
        document.documentElement.style.setProperty('--fp-current-section', activeIndex);
        
        // Update sections count if changed
        var sections = getSections();
        if (sections.length > 0) {
            document.documentElement.style.setProperty('--fp-sections-count', sections.length);
        }
    }
    
    // Update active dot on scroll end
    var scrollObserverTimer = null;
    var lastScrollTime = 0;
    var lastTargetSection = -1;
    
    function onScrollObserved() {
        // Don't update during animation
        if (isAnimating) return;
        
        var now = performance.now();
        // Only update if enough time has passed since last scroll
        if (now - lastScrollTime < 200) return;
        
        if (scrollObserverTimer) clearTimeout(scrollObserverTimer);
        scrollObserverTimer = setTimeout(function () {
            var idx = getCurrentSectionIndex();
            
            // Only update if we're actually at a different section
            if (idx !== lastTargetSection) {
                updateDots(idx);
                lastTargetSection = idx;
                lastScrollTime = performance.now();
            }
        }, 200);
    }
    
    function addScrollObserver() {
        window.addEventListener('scroll', onScrollObserved, { passive: true });
    }
    
    // ===== CSS Injection for Visual Dots =====
    function injectCSS() {
        if (document.getElementById('fp-dots-css')) return;
        
        var style = document.createElement('style');
        style.id = 'fp-dots-css';
        style.textContent = `
            :root {
                --fp-current-section: 0;
                --fp-sections-count: 3;
            }
            
            .fp-dots::before {
                content: '';
                position: absolute;
                right: 50%;
                top: 0;
                bottom: 0;
                width: 2px;
                background: rgba(255, 255, 255, 0.3);
                transform: translateX(50%);
            }
            
            .fp-dots::after {
                content: '';
                position: absolute;
                right: 50%;
                top: 0;
                width: 2px;
                background: #fff;
                height: calc(100% / var(--fp-sections-count));
                transition: transform 0.3s ease;
                transform: translateX(50%) translateY(calc(var(--fp-current-section) * 100% / var(--fp-sections-count)));
            }
            
            @keyframes fp-dot-pulse {
                0%, 100% { box-shadow: 0 0 20px rgba(255, 255, 255, 0.6); }
                50% { box-shadow: 0 0 30px rgba(255, 255, 255, 0.8); }
            }
        `;
        
        document.head.appendChild(style);
    }
    
    // ===== Initialization & resize handling =====
    function refreshSectionsAndDots() {
        updateDots(getCurrentSectionIndex());
    }
    
    var resizeTimer = null;
    function onResize() {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            refreshSectionsAndDots();
        }, 150);
    }
    
    // Public init
    function init() {
        // Inject CSS for visual dots
        injectCSS();
        
        // Bind listeners
        window.addEventListener('wheel', onWheel, { passive: false });
        window.addEventListener('keydown', onKeyDown, { passive: false });
        
        initDots();
        addScrollObserver();
        window.addEventListener('resize', onResize);
        
        // Initial sync
        refreshSectionsAndDots();
    }
    
    // Auto-init on DOMContentLoaded or immediately if already loaded
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    
    // Expose simple API for manual control
    window.FPSectionSnap = {
        next: function () { return nextSection(); },
        prev: function () { return prevSection(); },
        goTo: function (i) { return goToSection(i); },
        getCurrentIndex: function () { return getCurrentSectionIndex(); },
        isAnimating: function () { return !!isAnimating; }
    };
})();
    